import PageHeader from "core/components/Header/PageHeader";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { useScrollToTop } from "core/hooks/useScrollToTop";
import { _t } from "core/language";
import AppLayout from "core/layouts/AppLayout";
import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useRecipe } from "../hooks/recipe";
import { RouterName } from "core/router";
import TabComponent from "core/components/Tab/TabComponent";
import BottomNavigation from "core/layouts/BottomNavigation";
import MyIngredientTab from "./MyIngredientTab";
import HistoryTab from "./HistoryTab";

const MyKitchen = () => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab] = useState<number>(searchParams.get("tab") === "history" ? 1 : 0);
  useScrollToTop();
  const navigate = useCustomNavigate();
  const { resetRecipes } = useRecipe();

  const [isShowListIngredient, setIsShowListIngredient] =
    useState<boolean>(false);

  const handleShowListIngredient = (value: any) => {
    console.log("handleShowListIngredient");
    
    setIsShowListIngredient(value);
  };

  const handleGoBack = () => {
    console.log('handleGoBack');
    console.log('isShowListIngredient', isShowListIngredient);
    
    if (isShowListIngredient) {
      setIsShowListIngredient(false);
    } else {
      console.log('location?.search', location?.search);
      if (
        !location?.search &&
        !location?.search.includes(`backPage=${RouterName.AI_CHEF_INGREDIENTS}`)
      ) {
        console.log('resetRecipes');
        
        resetRecipes();
      }
    }
    navigate(-1);
  };
  const tabs = [
    {
      title: _t("ingredient.myIngredient"),
      content: (
        <div>
          <MyIngredientTab handleSetShowListIngredient={handleShowListIngredient}/>
        </div>
      ),
    },
    {
      title: _t("ingredient.history"),
      content: (
        <div>
          <HistoryTab />
        </div>
      ),
    },
  ];
  useEffect(() => {
    if (!searchParams.get("tab")) {
      searchParams.set("tab", "my-ingredient");
      setSearchParams(searchParams, { replace: true });
      navigate(location.pathname + "?" + searchParams.toString(), {
        replace: true,
      });
    }
  }, [searchParams.get("tab")]);

  const onClickTab = (index: number) => {
    console.log("onClickTab", index);
    
    if (index === 0) {
      console.log("MyIngredientTab");
      searchParams.set("tab", "my-ingredient");
      setSearchParams(searchParams);
    } else {
      console.log("HistoryTab");
      searchParams.set("tab", "history");
      setSearchParams(searchParams);
    }
    navigate(location.pathname + "?" + searchParams.toString(), {
      replace: true,
    });
  };

  console.log(activeTab, 'activeTab');
  
  
  return (
    <AppLayout>
      <PageHeader
        title={_t("ingredient.title")}
        handleGoBack={handleGoBack}
        sticky
      />

      <TabComponent tabs={tabs} active={activeTab} handleClickTab={onClickTab} />

      <BottomNavigation
        onNavigateChange={() => {
          if (
            !location?.search &&
            !location?.search.includes(
              `backPage=${RouterName.AI_CHEF_INGREDIENTS}`
            )
          ) {
            resetRecipes();
          }
        }}
        activeIndex={2}
      />
    </AppLayout>
  );
};

export default MyKitchen;
